// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import EleveService from '../../services/EleveService';
import MaterielService from '../../services/MaterielService';
import LocalService from '../../services/LocalService';

const OffcanvasAddMaterielForm = ({ onClick }) => {
	const [eleveOptions, setEleveOptions] = useState([]);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [LocalOptions, setLocalOptions] = useState([]);

	useEffect(() => {
		const fetchEleveOptions = async () => {
			try {
				const eleves = await EleveService.getEleveOptions();
				setEleveOptions(eleves);
			} catch (error) {
				console.error('Error fetching students options', error);
			}
		};

		fetchEleveOptions();
	}, []);

	const ETAT_CHOICES = [
		{ value: 'neuf', label: 'Neuf' },
		{ value: 'bon', label: 'Bon' },
		{ value: 'usé', label: 'Usé' }
	];

	let etat = 'neuf'; // Default value

	// To set the default value dynamically, you can find the choice object based on the value and assign the corresponding label
	const defaultChoice = ETAT_CHOICES.find((choice) => choice.value === etat);
	if (defaultChoice) {
		etat = defaultChoice.value;
	}

	useEffect(() => {
		const fetchLocalOptions = async () => {
			try {
				const Locals = await LocalService.getLocalOptions();
				setLocalOptions(Locals);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchLocalOptions();
	}, []);

	const Local_CHOICES = LocalOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const materielData = new FormData();

				// Add all your form data to the FormData
				materielData.append('nom', form.nom.value);
				materielData.append('description', form.description.value);
				materielData.append('fournisseur', form.fournisseur.value);
				materielData.append('local', form.local.value);
				materielData.append('date_achat', form.date_achat.value);
				materielData.append('quantite', form.quantite.value);
				materielData.append('cout', form.cout.value);
				materielData.append('etat', etat);

				// Call the MaterielService to create the Materiel
				const response = await MaterielService.createMateriel(materielData);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of Materiels
				window.location.href = '/assets/materiels';
			} catch (error) {
				console.error('Erreur lors de la création du matériel', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				<Col xs={12} className="mb-3">
					{/* nom  */}
					<Form.Group>
						<Form.Label htmlFor="nom">
							Nom <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="nom"
							type="text"
							placeholder="Saisir le nom du Materiel"
							id="nom"
							required
							isInvalid={!!feedbackMessages['nom']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									nom: e.target.value ? '' : 'Le nom est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['nom']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/*  description  */}
				<Col xs={12} className="mb-3">
					<Form.Group>
						<Form.Label htmlFor="description">
							Description <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="description"
							as="textarea"
							placeholder="Saisir la description du Materiel"
							id="description"
							required
							isInvalid={!!feedbackMessages['description']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									description: e.target.value
										? ''
										: 'La description est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['description']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* date_achat */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="date_achat">
							Date de l'achat <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="date_achat"
							type="date"
							placeholder="Saisir la date de l'achat du Materiel"
							id="date_achat"
							required
							isInvalid={!!feedbackMessages['date_achat']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									date_achat: e.target.value
										? ''
										: "La date de l'achat est requise."
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['date_achat']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/*  cout  */}
					<Form.Group>
						<Form.Label htmlFor="cout">Cout</Form.Label>
						<Form.Control
							name="cout"
							type="number"
							placeholder="Saisir le cout du Materiel"
							id="cout"
							required
							isInvalid={!!feedbackMessages['cout']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									cout: e.target.value ? '' : 'Le cout est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['cout']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* fournisseur */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="fournisseur">
							Fournisseur <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="fournisseur"
							type="text"
							placeholder="Saisir le fournisseur du Materiel"
							id="fournisseur"
							required
							isInvalid={!!feedbackMessages['fournisseur']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									fournisseur: e.target.value
										? ''
										: 'Le fournisseur est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['fournisseur']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/* quantite  */}
					<Form.Group>
						<Form.Label htmlFor="quantite">
							Quantite <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="quantite"
							type="number"
							placeholder="Saisir la quantite de Materiel"
							id="quantite"
							required
							isInvalid={!!feedbackMessages['quantite']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									quantite: e.target.value ? '' : 'La quantite est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['quantite']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* etat */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="etat">
							Etat <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="etat"
							required
							isInvalid={!!feedbackMessages['etat']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									etat: e.target.value ? '' : "L'etat du Materiel est requis."
								}));
							}}
						>
							{ETAT_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['etat']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* local */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="local">
							Local <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="local"
							required
							isInvalid={!!feedbackMessages['local']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									local: e.target.value
										? ''
										: 'Le local du Materiel est requis.'
								}));
							}}
						>
							{Local_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['local']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddMaterielForm;
